module.exports = __webpack_public_path__ + "static/media/CT_2019_30449A.0a331220.png";